import { supabase } from '../lib/supabase';

export async function storeOAuthState(userId: string, state: string) {
  const expiresAt = new Date();
  expiresAt.setMinutes(expiresAt.getMinutes() + 10); // State expires in 10 minutes

  const { error } = await supabase
    .from('nrm_oauth_states')
    .insert([{
      user_id: userId,
      state,
      expires_at: expiresAt.toISOString()
    }]);

  if (error) throw error;
}

export async function verifyOAuthState(state: string) {
  const { data, error } = await supabase
    .from('nrm_oauth_states')
    .select('user_id')
    .eq('state', state)
    .gt('expires_at', new Date().toISOString())
    .single();

  if (error || !data) return null;
  return data.user_id;
}

export async function cleanupOAuthState(state: string) {
  await supabase
    .from('nrm_oauth_states')
    .delete()
    .eq('state', state);
}